<script lang="ts">
    export let src: string;
    export let alt: string = "";
    export let className: string = "";
  </script>
  
  <div class={`flex justify-center items-center ${className}`}>
    <img src={src} alt={alt} class="w-full h-full object-contain overflow-hidden shadow-md" />
  </div>
